<template>
  <modal
    v-bind="$attrs"
    v-on="$listeners"
    :title="title"
    :errors="{}"
  >
    <template v-slot:header>
    </template>
    <template v-slot:body>
      <el-table
        :data="lessons"
        style="width: 100%"
        class="lesson-detail"
        header-row-class-name="assessment-header"
        :empty-text="$t('common.no_values')"
      >
        <base-table-column
          sortable
          prop="module_name"
          align="center"
          :label="$t('classes.classes_details.students_section.module_name')"
        />
        <base-table-column
          sortable
          prop="lesson_name"
          align="center"
          :label="$t('classes.classes_details.students_section.lesson_name')"
        />
        <base-table-column
          sortable
          prop="overall_native_score"
          align="center"
          :formatter="percentageFormatter"
          :label="$t('classes.classes_details.students_section.lesson_EPS')"
        />
        <base-table-column
          sortable
          dataType="date"
          prop="date"
          align="center"
          dateFormat="HH:mma, MM/dd/yyyy"
          :label="$t('classes.classes_details.students_section.lesson_take_date')"
        />
        <base-table-column
          sortable
          prop="difficulty_level"
          align="center"
          :label="$t('classes.classes_details.students_section.difficulty_level')"
        />
      </el-table>
      <div class="actions">
        <primary-button
          @click.native="closeModal"
        >
          OK
        </primary-button>
      </div>
    </template>
  </modal>
</template>

<script>
  import Modal from '@/components/common/Modal'
  import PrimaryButton from '@/components/common/buttons/PrimaryButton'
  import percentage from '@/components/common/mixins/percentage'
  import {unless, isNil } from 'ramda'
  import BaseTableColumn from '@/components/classes/BaseTableColumn'

  export default {
    components: {
      Modal,
      PrimaryButton,
      BaseTableColumn,
    },
    props: {
      lessons: {
        type: Array,
      },
      title: {
        type: String
      },
    },
    methods: {
      closeModal() {
        this.$emit('closed')
      },
      percentageFormatter(row, column, cellValue, index) {
        if(cellValue == 0) return null;
        return percentage.filters.toPercentage(unless(isNil, Math.round)(cellValue));
      },
    }
  }
</script>

<style lang="scss" scoped>
.lesson-detail {
    padding-bottom: 10px !important;
}
.actions {
  align-items: flex-start;
  .el-button {
    padding: 12px;
  }
}
::v-deep .el-dialog.elsa-modal {
    width: 70%;
}
</style>
